import React, { useState, useEffect } from "react";
import Respect from "../assets/Respect";
import Honesty from "../assets/Honesty";
import Servant from "../assets/Servant";
import Responsibility from "../assets/Responsibility";
import NextArrow from "../assets/NextArrow";
import PrevArrow from "../assets/PrevArrow";
import Pride from "../assets/Pride";
import Commitment from "../assets/Commitment";
import Continuity from "../assets/Continuity";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
const icons = {
  RESPECT: <Respect />,
  HONESTY: <Honesty />,
  SERVANT: <Servant />,
  RESPONSIBILITY: <Responsibility />,
  PRIDE: <Pride />,
  COMMITMENT: <Commitment />,
  CONTINUITY: <Continuity />,
};

const Vision = () => {
  const t = useTranslations("aboutUs.visionSlider");
  const router = useRouter();
  const [arrayofNumber, setArrayofNumber] = useState([1, 2, 3, 4, 5, 6, 7]);
  const [arrow, setArrow] = useState(
    router.locale == "en"
      ? { isEnd: false, isBeginning: true }
      : { isEnd: true, isBeginning: false }
  );
  const result = arrayofNumber.map((element, index) => {
    const icon = icons[t(`${index}.icon`)];
    return (
      <>
        <SwiperSlide virtualIndex={index}>
          <div
            className=" flex items-center w-[100%]  justify-center  h-[309px] "
            key={element.title}
          >
            <div className=" w-[278px] gap-[10px] h-[247px] rounded-[8px] ">
              <div className="w-[278px] h-[247px] relative flex justify-center">
                <div>
                  <span className="bg-[#36A9E1] rounded-[100px] w-[64px] h-[64px] flex items-center top-[0]  justify-center ">
                    {icon}
                  </span>
                  <h3 className="text-[#36A9E1] text-[24px] leading-[26px] font-[590] w-[213px]  mt-[5px] mb-[5px]">
                    {t(`${index}.title`)}
                  </h3>
                  <p className="text-[#010140] w-[231px] leading-[24px] ">
                    {t(`${index}.descrption`)}
                  </p>
                </div>

                <div className="absolute bg-[#36A9E1] opacity-[5%] w-[100%]  top-[30px] h-full rounded-[8px]"></div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </>
    );
  });
  return (
    <div className=" max-w-[90rem] m-auto  flex flex-col justify-center items-center  mds:mt-[5rem] ">
      <div className=" w-[80%] visionSlider flex items-center justify-center  relative  ">
        <div className="  w-[100%]  h-[309px] ">
          <Swiper
            key={router.locale}
            slidesPerView={1}
            modules={[Navigation]}
            breakpoints={{
              450: { slidesPerView: 1.3, spaceBetween: 0 },
              550: { slidesPerView: 1.5, spaceBetween: 0 },
              660: { slidesPerView: 2, spaceBetween: 0 },
              800: { slidesPerView: 2.5, spaceBetween: 50 },
              949: { slidesPerView: 3, spaceBetween: 0 },
              1200: { slidesPerView: 3.5, spaceBetween: 0 },
              1361: { slidesPerView: 4, spaceBetween: 0 },
            }}
            onSwiper={(swiper) => (next = swiper)}
            onSlideChange={(swiper) =>
              setArrow(
                router.locale == "en"
                  ? { isEnd: swiper.isEnd, isBeginning: swiper.isBeginning }
                  : { isEnd: swiper.isBeginning, isBeginning: swiper.isEnd }
              )
            }
          >
            {result}
          </Swiper>
          <button
            className="previous absolute left-[-26px] top-[50%] z-[100] "
            onClick={() =>
              router.locale == "en" ? next.slidePrev() : next.slideNext()
            }
          >
            <PrevArrow arrow={arrow} />
          </button>
          <button
            className="next absolute right-[-26px] top-[50%] z-[100]"
            onClick={() => {
              router.locale == "en" ? next.slideNext() : next.slidePrev();
            }}
          >
            <NextArrow arrow={arrow} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vision;
